import { Component } from '@angular/core';
import { GlobalService } from '../../core/services/global.service';

@Component({
  selector: 'app-rightsidebar',
  templateUrl: './rightsidebar.component.html',
  styleUrls: ['./rightsidebar.component.scss']
})

/**
 * Rightsidebar component
 */
export class RightsidebarComponent {

  constructor(
    private readonly globalService: GlobalService
  ) { }
  /**
   * Hide the sidebar
   */
  public hide(): void {
    this.globalService.nativeDocument.body.classList.remove('right-bar-enabled');
  }

}
